import React from "react";
import { useTranslation } from "react-i18next";
import ContributorCard from "../components/ContributorCard";
import "./Thanks.css";

function Thanks() {
  const { t } = useTranslation();
  const contributors = [
    {
      name: "Satochip",
      description: t("thanks.satochipDesc"),
      links: [
        { label: "Product", url: "https://satochip.io/product/satochip/" },
        { label: "Toporin GitHub", url: "https://github.com/Toporin" }
      ]
    },
    {
      name: "SeedSigner",
      description: t("thanks.seedsignerDesc"),
      links: [
        { label: "GitHub", url: "https://github.com/SeedSigner/seedsigner" }
      ]
    },
    {
      name: "3rd Iteration",
      description: t("thanks.thirdIterationDesc"),
      links: [
        { label: "GitHub", url: "https://github.com/3rdIteration/seedsigner" },
        { label: "YouTube", url: "https://www.youtube.com/@CryptoGuide" },
        { label: "Twitter", url: "https://x.com/YTCryptoGuide" }
      ]
    }
  ];

  const shoutouts = [
    {
      name: "No Waste BTC Signs",
      description: t("thanks.noWasteDesc"),
      links: [
        { label: "Instagram", url: "https://www.instagram.com/nowastebtcsigns/" },
        { label: "Twitter", url: "https://x.com/NoWasteBTCsigns" }
      ]
    }
  ];

  return (
    <div className="thanks">
      <h1>{t("thanks.title")}</h1>
      
      <div className="image-section">
        <img 
          src={`${process.env.PUBLIC_URL}/assets/images/seedsigner/image_02.jpg`}
          alt="SeedSigner device showing success message"
          className="thanks-image"
        />
      </div>
      
      <div className="contributors-section">
        <h2>{t("thanks.contributorsTitle")}</h2>
        <div className="contributors-grid">
          {contributors.map((contributor, index) => (
            <ContributorCard
              key={index}
              name={contributor.name}
              description={contributor.description}
              links={contributor.links}
            />
          ))}
        </div>
      </div>

      <div className="shoutouts-section">
        <h2>{t("thanks.shoutoutsTitle")}</h2>
        <div className="contributors-grid">
          {shoutouts.map((shoutout, index) => (
            <ContributorCard
              key={index}
              name={shoutout.name}
              description={shoutout.description}
              links={shoutout.links}
              logo={shoutout.logo}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Thanks;

